export const tipologiaUtente = {
	referenteComunale: "REFERENTE_COMUNALE",
	operatoreComunale: "OPERATORE_COMUNALE"
}
